/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToPaymentAccount/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ToPaymentAccount({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/EntryType/TransferCredit/ToPaymentAccount"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let entryTransactionAppliedPaymentPaymentAccountIdValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'transaction.applied_payment.payment].account.id',
})
let entryTransactionAppliedPaymentPayments0AccountIdValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'transaction.applied_payment.payments[0].account.id',
format: fromFormat.not,
})
let aggregateData = fromAggregate.equals(entryTransactionAppliedPaymentPaymentAccountIdValueData, entryTransactionAppliedPaymentPayments0AccountIdValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}